module.exports = __webpack_public_path__ + "static/media/Janelle and Melissa Brick Wall_2.d4c74cad.jpg";